import { BasicTable } from "../../../../../components/BasicTable";
import { Spinner } from "../../../../../components/ui/spinner";
import { SellerCommissionFilter } from "../SellerCommissionFilter";
import { useSellerCommissionTableController } from "./useSellerCommissionTableController";
import { EmptyWithDrawsTable } from "../../../../../components/EmptyWithDrawsTable";
import { MakeWithdrawalModal } from "../MakeWithdrawalModal";
import { Button } from "@/view/components/ui/button";
import { Plus } from "lucide-react";

export const SellerCommissionTable = () => {
  const {
    handleNextPage,
    handlePreviousPage,
    isFetching,
    isLoading,
    table,
    getPageCount,
    getPageIndex,
    ErrorWithdrawModal,
    isSuperAdmin,
    isModalOpen,
    setIsModalOpen,
    handleProofClick,
  } = useSellerCommissionTableController();

  return (
    <div className="w-full">
      {getPageCount() > 0 && (
        <>
          <div className="my-5 flex items-center justify-between">
            <h2 className="text-xl font-semibold">Saques realizados</h2>
            <div className="flex items-center gap-4">
              {isSuperAdmin && (
                <Button onClick={() => setIsModalOpen(true)}>
                  <div className="flex h-4 w-4 items-center justify-center rounded-full bg-white">
                    <Plus size={14} className="text-primary" />
                  </div>
                </Button>
              )}
              <SellerCommissionFilter />
            </div>
          </div>
        </>
      )}
      {(isFetching || isLoading) && (
        <div className="flex h-screen items-center justify-center">
          <Spinner />
        </div>
      )}

      {!isFetching && (
        <div className="w-full">
          {getPageCount() > 0 ? (
            <div>
              <BasicTable
                getPageCount={getPageCount}
                getPageIndex={getPageIndex}
                handleNextPage={handleNextPage}
                handlePreviousPage={handlePreviousPage}
                handleRowClick={handleProofClick}
                table={table}
                type="only header"
              />
              {ErrorWithdrawModal}
            </div>
          ) : (
            <EmptyWithDrawsTable />
          )}
        </div>
      )}

      <MakeWithdrawalModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};
